var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time"},[_vm._v(" "+_vm._s(_vm._f("dateFormat")(_vm.date))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }